/**
 * The one definition of which map views a reader is offered.
 *
 * Four places need to agree on this and would silently drift if each filtered
 * for itself: the public map (which views get a tab), BlockRenderer (whether
 * the section renders at all), the editor's "this is the only view showing"
 * warning, and the page outline's summary. A disagreement between the last two
 * and the first two is an editor that reports the site wrongly.
 *
 * Deliberately its own module rather than a helper in lib/content.ts, which
 * imports lib/store.ts and would drag the AWS SDK into the editor bundle, or in
 * lib/editable.ts, which is about what a REQUEST may change — a different
 * question from what a reader may see.
 */

import type { PolicyMapTab } from "@/lib/content";

/**
 * `tabs` is typed as required but arrives from DynamoDB, where a record can
 * predate the deployed schema or simply be malformed — savePageDraft passes
 * unparseable records through on purpose (ADR-0004). An absent array is
 * therefore a real input, and it means "no views", not a crash.
 */
export function visibleTabs(tabs: PolicyMapTab[] | undefined): PolicyMapTab[] {
  return Array.isArray(tabs) ? tabs.filter((t) => !t.hidden) : [];
}
